import { PlessViewUtilsSub } from '../../../../commons/kymw00/pless-view-utils-sub.service';
import { CheckPlanGoodsRequestModel } from '../vo/kymw0900-check-plan-goods-request.model';
import { KYMW0900Model } from '../kymw0900.model';
import { PlessAlert } from '../../../../shared/pless-alert/pless-alert.component';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 商品企画マスタ変更確認サービス
 *
 * @export CheckPlanGoodsService
 * @class CheckPlanGoodsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckPlanGoodsService extends PlessJsonResponderSub<any> {

  /** KYMW0900Model */
  model = new KYMW0900Model();

  /** ワーニングメッセージ格納領域 */
  private arrayWarningMsg: any = null;
  /** ワーニングメッセージIndex */
  private warningMsgIndex = Number(0);

  private _serverData: any; // サーバーデータを一時待避

  /**
   * 処理に使用するvo
   *
   * @private
   * @type {CheckPlanGoodsRequestModel}
   * @memberof CheckPlanGoodsService
   */
  private vo: CheckPlanGoodsRequestModel = null;


  /**
   * API成功時後続処理
   *
   * @private
   * @type {Function}
   * @memberof CheckPlanGoodsService
   */
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckPlanGoodsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      regist: {
        PlanGoodsBase: {
          parameter: {
            OrderCode: this.vo.planGoodsBaseVO.orderCode,
            PCode: this.vo.planGoodsBaseVO.pCode,
            ClassDivNum: this.vo.planGoodsBaseVO.classDivNum,
            PackMaterialShowFlg: this.vo.planGoodsBaseVO.packMaterialShowFlg,
            ClassCode: this.vo.planGoodsBaseVO.classCode,
            LargeClassCode: this.vo.planGoodsBaseVO.largeClassCode,
            MiddleClassCode: this.vo.planGoodsBaseVO.middleClassCode,
            SmallClassCode: this.vo.planGoodsBaseVO.smallClassCode,
            DataType: this.vo.planGoodsBaseVO.dataType,
            GuideGoodsName: this.vo.planGoodsBaseVO.guideGoodsName,
            GuideStandardName: this.vo.planGoodsBaseVO.guideStandardName,
            MediumType: this.vo.planGoodsBaseVO.mediumType,
            DeliveryGoodsNameKanji: this.vo.planGoodsBaseVO.deliveryGoodsNameKanji,
            DeliveryGoodsNameKana: this.vo.planGoodsBaseVO.deliveryGoodsNameKana,
            DeliveryStandardNameKanji: this.vo.planGoodsBaseVO.deliveryStandardNameKanji,
            DeliveryStandardNameKana: this.vo.planGoodsBaseVO.deliveryStandardNameKana,
            OcrGoodsName: this.vo.planGoodsBaseVO.ocrGoodsName,
            ConsumeTaxDiv: this.vo.planGoodsBaseVO.consumeTaxDiv,
            ConsumeTaxRate: this.vo.planGoodsBaseVO.consumeTaxRate,
            CycleTerm: this.vo.planGoodsBaseVO.cycleTerm,
            EdlpDiv: this.vo.planGoodsBaseVO.edlpDiv,
            UnitPriceDiv: this.vo.planGoodsBaseVO.unitPriceDiv,
            UnitPriceCoefficient: this.vo.planGoodsBaseVO.unitPriceCoefficient,
            UnitPriceUnit: this.vo.planGoodsBaseVO.unitPriceUnit,
            ConsumeTerm: this.vo.planGoodsBaseVO.consumeTerm,
            ConsumeByDate: this.vo.planGoodsBaseVO.consumeByDate,
            LeaveConsumeTerm: this.vo.planGoodsBaseVO.leaveConsumeTerm,
            GuideTempZoneDiv: this.vo.planGoodsBaseVO.guideTempZoneDiv,
            RelationPCodeOld: this.vo.planGoodsBaseVO.relationPCodeOld,
            RelationPCodeNew: this.vo.planGoodsBaseVO.relationPCodeNew,
            BlindDiv: this.vo.planGoodsBaseVO.blindDiv,
            EFriendsSendDiv: this.vo.planGoodsBaseVO.eFriendsSendDiv,
            KomaScheduleDiv: this.vo.planGoodsBaseVO.komaScheduleDiv,
            LiquorCode: this.vo.planGoodsBaseVO.liquorCode,
            AlocoholType: this.vo.planGoodsBaseVO.alocoholType,
            ContainerForm: this.vo.planGoodsBaseVO.containerForm,
            ContainerCapacity: this.vo.planGoodsBaseVO.containerCapacity,
            ListingGoodsName: this.vo.planGoodsBaseVO.listingGoodsName,
            BuyerComment: this.vo.planGoodsBaseVO.buyerComment,
            StinkGoodsDiv: this.vo.planGoodsBaseVO.StinkGoodsDiv,
            CaseSupplyDiv: this.vo.planGoodsBaseVO.CaseSupplyDiv,
            LongKeepDiv: this.vo.planGoodsBaseVO.LongKeepDiv,
            ArrivalAreaDiv: this.vo.planGoodsBaseVO.ArrivalAreaDiv,
            ArrivalGoodsTemp: this.vo.planGoodsBaseVO.ArrivalGoodsTemp,
            ArrivalAdminDays: this.vo.planGoodsBaseVO.ArrivalAdminDays,
            DutiesFormDailyDiv: this.vo.planGoodsBaseVO.DutiesFormDailyDiv,
            PlanNumTotal: this.vo.planGoodsBaseVO.planNumTotal,
            LotteryPromotionFlg: this.vo.planGoodsBaseVO.lotteryPromotionFlg,
            PointPromotionFlg: this.vo.planGoodsBaseVO.pointPromotionFlg,
            NvalPromotionFlg: this.vo.planGoodsBaseVO.nvalPromotionFlg,
            CouponPromotionFlg: this.vo.planGoodsBaseVO.couponPromotionFlg,
            StockLimitFlg: this.vo.planGoodsBaseVO.stockLimitFlg,
            PreOrderFlg: this.vo.planGoodsBaseVO.preOrderFlg,
            RegularFlg: this.vo.planGoodsBaseVO.regularFlg,
          },
        },
        PlanGoodsCoop: {
          combination:
            this.vo.planGoodsCoopList.map(planGoodsCoop => {
              return {
                parameter: {
                  OrderCode: planGoodsCoop.orderCode,
                  PCode: planGoodsCoop.pCode,
                  CoopCode: planGoodsCoop.coopCode,
                  DealCoopDiv: PlessViewUtilsSub.booleanTOString(planGoodsCoop.dealCoopDiv),
                  SystemMark1: PlessViewUtilsSub.booleanTOString(planGoodsCoop.systemMark1),
                  SystemMark2: PlessViewUtilsSub.booleanTOString(planGoodsCoop.systemMark2),
                  SystemMark3: PlessViewUtilsSub.booleanTOString(planGoodsCoop.systemMark3),
                  SystemMark4: PlessViewUtilsSub.booleanTOString(planGoodsCoop.systemMark4),
                  SystemMark5: PlessViewUtilsSub.booleanTOString(planGoodsCoop.systemMark5),
                  ItemCode: planGoodsCoop.itemCode,
                  PricePatern: planGoodsCoop.pricePatern,
                  ThisTimeSupplyPrice: planGoodsCoop.thisTimeSupplyPrice,
                  ThisTimeCostPrice: planGoodsCoop.thisTimeCostPrice,
                  BrandType: planGoodsCoop.brandType,
                  SetDiv: planGoodsCoop.setDiv,
                  AssortTempDiv: planGoodsCoop.assortTempDiv,
                  OrderNumQuotaCode: planGoodsCoop.orderNumQuotaCode,
                  DetailUseRegularFlg: planGoodsCoop.detailUseRegularFlg,
                  ProducingAreaComment1: planGoodsCoop.producingAreaComment1,
                  ProducingAreaComment2: planGoodsCoop.producingAreaComment2,
                  ReceiptNum: planGoodsCoop.receiptNum,
                  PlanNum: planGoodsCoop.planNum,
                  LimitNumTotal: planGoodsCoop.limitNumTotal,
                  LimitNumPerson: planGoodsCoop.limitNumPerson,
                  DeliveryLeadTimeType: planGoodsCoop.deliveryLeadTimeType,
                  DelivCatalogID: planGoodsCoop.delivCatalogID,
                  AppearDiv: planGoodsCoop.appearDiv,
                  UseRegularFlg: planGoodsCoop.useRegularFlg
                }
              }
            })
        },
        PlanGoodsNextGuide: {
          combination: this.vo.planGoodsNextGuide.map(planGoodsNextGuideInfo => {
            return {
              parameter: {
                CoopCode: planGoodsNextGuideInfo.coopCode,
                MediumType: planGoodsNextGuideInfo.mediumType,
                NextGuide: planGoodsNextGuideInfo.nextGuide,
              }
            }
          })
        },
        PlanGoodsDetail: {
          combination: this.vo.planGoodsDetailList.map(planGoodsDetail => {
            return {
              parameter: {
                OrderCode: planGoodsDetail.orderCode,
                PCode: planGoodsDetail.pCode,
                ItemCode: planGoodsDetail.itemCode,
                JANCode: planGoodsDetail.jANCode,
                JANCodeDiv: planGoodsDetail.janCodeDiv,
                FCMCFee: planGoodsDetail.fCMCFee,
                SpecialOrderType: planGoodsDetail.specialOrderType,
                StockType: planGoodsDetail.stockType,
                InstallmentTimes: planGoodsDetail.installmentTimes,
                PDPilingUpDays: planGoodsDetail.pDPilingUpDays,
                OrderUnitType: planGoodsDetail.orderUnitType,
                PriceType: planGoodsDetail.priceType,
                MakerPrice: planGoodsDetail.makerPrice,
                OrderClientCode: planGoodsDetail.orderClientCode,
                PayeeClientCode: planGoodsDetail.payeeClientCode,
                BundlePrice: planGoodsDetail.bundlePrice,
                FixContainNum: planGoodsDetail.fixContainNum,
                SetQuantity: planGoodsDetail.setQuantity,
                MakerName: planGoodsDetail.makerName,
                MakerNamePublishType: planGoodsDetail.makerNamePublishType,
                PeaceSizeLength: planGoodsDetail.peaceSizeLength,
                PeaceSizeWidth: planGoodsDetail.peaceSizeWidth,
                PeaceSizeHight: planGoodsDetail.peaceSizeHight,
                PeaceWeight: planGoodsDetail.peaceWeight,
                CaseSizeLength: planGoodsDetail.caseSizeLength,
                CaseSizeWidth: planGoodsDetail.caseSizeWidth,
                CaseSizeHight: planGoodsDetail.caseSizeHight,
                CaseWeight: planGoodsDetail.caseWeight,
                GeneRecombinationDiv: planGoodsDetail.geneRecombinationDiv,
                AnalysisUnit: planGoodsDetail.analysisUnit,
                Calorie: planGoodsDetail.calorie,
                Protein: planGoodsDetail.protein,
                Lipid: planGoodsDetail.lipid,
                Carbohydrate: planGoodsDetail.carbohydrate,
                Sodium: planGoodsDetail.sodium,
                AllergenTargetType: planGoodsDetail.allergenTargetType
              }
            }
          })
        },
        PlanGoodsListing: {
          combination: this.vo.planGoodsListingList.map(planGoodsListing => {
            return {
              parameter: {
                OrderCode: planGoodsListing.orderCode,
                PCode: planGoodsListing.pCode,
                ListingItemID: planGoodsListing.listingItemID,
                DispContents: planGoodsListing.dispContents
              }
            }
          })
        },
        MarkPlanGoods: {
          combination: this.vo.markPlanGoodsList.map(markPlanGoods => {
            return {
              parameter: {
                OrderCode: markPlanGoods.orderCode,
                PCode: markPlanGoods.pCode,
                GoodsMarkCode: markPlanGoods.goodsMarkCode,
                GoodsMark: PlessViewUtilsSub.booleanTOString(markPlanGoods.goodsMark),
              }
            }
          })
        },
        PlanTextInfoGoods: {
          combination: this.vo.planTextInfoGoodsList.map(planTextInfoGoods => {
            return {
              parameter: {
                OrderCode: planTextInfoGoods.orderCode,
                PCode: planTextInfoGoods.pCode,
                TextKindID: planTextInfoGoods.textKindID,
                TextKindNum: planTextInfoGoods.textKindNum,
                StringValue: planTextInfoGoods.stringValue
              }
            }
          })
        },
        PlanTextInfoItem: {
          combination: this.vo.planTextInfoItemList.map(planTextInfoItem => {
            return {
              parameter: {
                OrderCode: planTextInfoItem.orderCode,
                ItemCode: planTextInfoItem.itemCode,
                TextKindID: planTextInfoItem.textKindID,
                TextKindNum: planTextInfoItem.textKindNum,
                StringValue: planTextInfoItem.stringValue
              }
            }
          })
        },
        UseMark: {
          combination: this.vo.useMarkList.map(useMark => {
            return {
              parameter: {
                OrderCode: useMark.orderCode,
                PCode: useMark.pCode,
                PromoteMarkCode: useMark.promoteMarkCode,
                PromoteMark0: PlessViewUtilsSub.booleanTOString(useMark.promoteMark0),
                PromoteMark1: PlessViewUtilsSub.booleanTOString(useMark.promoteMark1),
                PromoteMark2: PlessViewUtilsSub.booleanTOString(useMark.promoteMark2),
                PromoteMark3: PlessViewUtilsSub.booleanTOString(useMark.promoteMark3),
                PromoteMark4: PlessViewUtilsSub.booleanTOString(useMark.promoteMark4),
                PromoteMark5: PlessViewUtilsSub.booleanTOString(useMark.promoteMark5),
                PromoteMark6: PlessViewUtilsSub.booleanTOString(useMark.promoteMark6),
                PromoteMark7: PlessViewUtilsSub.booleanTOString(useMark.promoteMark7)
              }
            }
          })
        },
        PlanGoodsAllergen: {
          combination: this.vo.planGoodsAllergenList.map(planGoodsAllergen => {
            return {
              parameter: {
                OrderCode: planGoodsAllergen.orderCode,
                PCode: planGoodsAllergen.pCode,
                ItemCode: planGoodsAllergen.itemCode,
                AllergenDiv: planGoodsAllergen.allergenDiv,
                AllergenSelect: planGoodsAllergen.allergenSelect
              }
            }
          })
        },
        PlanGoodsEcology1: {
          combination: this.vo.planGoodsEcology1List.map(planGoodsEcology1 => {
            return {
              parameter: {
                OrderCode: planGoodsEcology1.orderCode,
                PCode: planGoodsEcology1.pCode,
                ItemCode: planGoodsEcology1.itemCode,
                EcologyDivFlag: planGoodsEcology1.ecologyDivFlag,
              }
            }
          })
        },
        PlanGoodsEcology2: {
          combination: this.vo.planGoodsEcology2List.map(planGoodsEcology2 => {
            return {
              parameter: {
                OrderCode: planGoodsEcology2.orderCode,
                PCode: planGoodsEcology2.pCode,
                ItemCode: planGoodsEcology2.itemCode,
                EcologyDiv: planGoodsEcology2.ecologyDiv,
                EcologyDivSelect: planGoodsEcology2.ecologyDivSelect,
              }
            }
          })
        },
        PlanGoodsGWStop: {
          combination: this.vo.itemCodePromoteList.map(itemCodePromote => {
            return {
              parameter: {
                OrderCode: itemCodePromote.orderCode,
                PCode: itemCodePromote.pCode,
                ItemCode: itemCodePromote.itemCode,
                GWStopGoodsDiv: itemCodePromote.gWStopGoodsDiv,
                GWStopGoodsDivSelect: itemCodePromote.gWStopGoodsDivSelect
              }
            }
          })
        },
        PlanGoodsContain: {
          combination: this.vo.planGoodsContainList.map(planGoodsContain => {
            return {
              parameter: {
                OrderCode: planGoodsContain.orderCode,
                PCode: planGoodsContain.pCode,
                ItemCode: planGoodsContain.itemCode,
                ContainDiv: planGoodsContain.containDiv,
                ContainKind: planGoodsContain.containKind,
                PackMaterialWeight: planGoodsContain.packMaterialWeight,
                ContainSelect: (planGoodsContain.containSelect === 'true' || planGoodsContain.containSelect === '1') ? '1' : '0'
              }
            }
          })
        },
        PlanGoodsNutritionUnit: {
          combination: this.vo.planGoodsNutritionUnitList.map(planGoodsNutritionUnit => {
            return {
              parameter: {
                OrderCode: planGoodsNutritionUnit.orderCode,
                PCode: planGoodsNutritionUnit.pCode,
                ItemCode: planGoodsNutritionUnit.itemCode,
                AnalysisSeqNo: planGoodsNutritionUnit.analysisSeqNo,
                AnalysisUnit: planGoodsNutritionUnit.analysisUnit,
                NutritionalNote: planGoodsNutritionUnit.nutritionalNote,
                MaintenanceDivUnit: planGoodsNutritionUnit.maintenanceDivUnit,
                MaintenanceDivNote: planGoodsNutritionUnit.maintenanceDivNote,
                ItemNameForForm: planGoodsNutritionUnit.itemNameForForm
              }
            }
          })
        },
        PlanGoodsNutritionDetail: {
          combination: this.vo.planGoodsNutritionDetailList.map(planGoodsNutritionDetail => {
            return {
              parameter: {
                OrderCode: planGoodsNutritionDetail.orderCode,
                PCode: planGoodsNutritionDetail.pCode,
                ItemCode: planGoodsNutritionDetail.itemCode,
                AnalysisSeqNo: planGoodsNutritionDetail.analysisSeqNo,
                NutritionalCode: planGoodsNutritionDetail.nutritionalCode,
                NutritionalQuantity: planGoodsNutritionDetail.nutritionalQuantity,
                MaintenanceDivQuantity: planGoodsNutritionDetail.maintenanceDivQuantity,
                ItemNameForForm: planGoodsNutritionDetail.itemNameForForm
              }
            }
          })
        },
        PlanGoodsLotteryPromotion: {
          combination: this.vo.planGoodsLotteryPromotion.map(planGoodsLotteryPromotion => {
            return {
              parameter: {
                ItemCode: planGoodsLotteryPromotion.itemCode,
                WinningGoodsNum: planGoodsLotteryPromotion.winningGoodsNum,
                WinningGoodsPerPersonNum: planGoodsLotteryPromotion.winningGoodsPerPersonNum,
                LimitedMeaning: planGoodsLotteryPromotion.limitedMeaning,
                MondayPlanNum: planGoodsLotteryPromotion.mondayPlanNum,
                TuesdayPlanNum: planGoodsLotteryPromotion.tuesdayPlanNum,
                WednesdayPlanNum: planGoodsLotteryPromotion.wednesdayPlanNum,
                ThursdayPlanNum: planGoodsLotteryPromotion.thursdayPlanNum,
                FridayPlanNum: planGoodsLotteryPromotion.fridayPlanNum,
              }
            }
          })
        },
        PointExchangeBase: {
          combination: this.vo.planGoodsPointExchangePromotion.map(planGoodsPointExchangeInfo => {
            return {
              parameter: {
                PCode: planGoodsPointExchangeInfo.pCode,
                ItemCode: planGoodsPointExchangeInfo.itemCode,
                PointExchangeOrderNumQuotaCode: planGoodsPointExchangeInfo.pointExchangeOrderNumQuotaCode,
                PointExchangeGoodsName: planGoodsPointExchangeInfo.pointExchangeGoodsName,
                PointExchangeGoodsNameKana: planGoodsPointExchangeInfo.pointExchangeGoodsNameKana,
                PointExchangeGuideName: planGoodsPointExchangeInfo.pointExchangeGuideName,
                PointExchangeGuideNameKana: planGoodsPointExchangeInfo.pointExchangeGuideNameKana,
                ShortOfPointDiv: planGoodsPointExchangeInfo.shortOfPointDiv,
                EcOnlyFlg: planGoodsPointExchangeInfo.ecOnlyFlg,
                RegistFlg: planGoodsPointExchangeInfo.registFlg,
                DeleteFlg: planGoodsPointExchangeInfo.deleteFlg,
              }
            }
          })
        },
        PointExchangeCoop: {
          combination: this.vo.planGoodsCoopPointRate.map(planGoodsCoopPointRateInfo => {
            return {
              parameter: {
                ItemCode: planGoodsCoopPointRateInfo.itemCode,
                CoopCode: planGoodsCoopPointRateInfo.coopCode,
                PointRate: planGoodsCoopPointRateInfo.pointRate,
                PointExchangeEquivalentAmount: planGoodsCoopPointRateInfo.pointExchangeEquivalentAmount,
                ExchangePoints: planGoodsCoopPointRateInfo.exchangePoints,
                RegistFlg: planGoodsCoopPointRateInfo.registFlg,
                DeleteFlg: planGoodsCoopPointRateInfo.deleteFlg,
              }
            }
          })
        },
        PlanGoodsNvalPromotion: {
          combination: this.vo.planGoodsNvalPromotion.map(planGoodsNvalPromotionInfo => {
            return {
              parameter: {
                PCode: planGoodsNvalPromotionInfo.pCode,
                NvalDetailId: planGoodsNvalPromotionInfo.nvalDetailId,
                MediumType: planGoodsNvalPromotionInfo.mediumType,
                ItemCode: planGoodsNvalPromotionInfo.itemCode,
                NvalOrderNumQuotaCode: planGoodsNvalPromotionInfo.nvalOrderNumQuotaCode,
                IbnkssaKb: planGoodsNvalPromotionInfo.ibnkssaKb,
                ShkkktantKb: planGoodsNvalPromotionInfo.shkkktantKb,
                NvalGoodsName: planGoodsNvalPromotionInfo.nvalGoodsName,
                NvalGoodsNameKana: planGoodsNvalPromotionInfo.nvalGoodsNameKana,
                NvalGuideName: planGoodsNvalPromotionInfo.nvalGuideName,
                NvalGuideNameKana: planGoodsNvalPromotionInfo.nvalGuideNameKana,
                DiscountType: planGoodsNvalPromotionInfo.nvalDiscountType,
                DiscountUnitPrice: planGoodsNvalPromotionInfo.nvalDiscountUnitPrice,
                DiscountRate: planGoodsNvalPromotionInfo.nvalDiscountRate,
                PricePattern: planGoodsNvalPromotionInfo.nvalPricePattern,
                SupplyPriceStandard: planGoodsNvalPromotionInfo.nvalSupplyPriceStandard,
                NvalDiscountSupplyUnitPrice: planGoodsNvalPromotionInfo.nvalDiscountSupplyUnitPrice,
                UsePrefecture1Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture1Flg),
                UsePrefecture2Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture2Flg),
                UsePrefecture3Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture3Flg),
                UsePrefecture4Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture4Flg),
                UsePrefecture5Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture5Flg),
                UsePrefecture6Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture6Flg),
                UsePrefecture7Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture7Flg),
                UsePrefecture8Flg: Number(planGoodsNvalPromotionInfo.nvalUsePrefecture8Flg),
                Remarks: planGoodsNvalPromotionInfo.remarks,
                RegistFlg: planGoodsNvalPromotionInfo.registFlg,
                DeleteFlg: planGoodsNvalPromotionInfo.deleteFlg
              }
            }
          })
        },
        PlanGoodsCouponPromotion: {
          combination: this.vo.planGoodsCouponPromotion.map(couponPromotionInfo => {
            return {
              parameter: {
                PCode: couponPromotionInfo.pCode,
                CouponGoodsNo: couponPromotionInfo.couponGoodsNo,
                ItemCode: couponPromotionInfo.itemCode,
                CouponType: couponPromotionInfo.couponType,
                GroupType: couponPromotionInfo.groupType,
                CouponOrderNumQuotaCode: couponPromotionInfo.couponOrderNumQuotaCode,
                NotificationFlg: couponPromotionInfo.notificationFlg,
                DeliveryFlg: couponPromotionInfo.deliveryFlg,
                NewsletterFlg: couponPromotionInfo.newsletterFlg,
                StandardUsageAmount: couponPromotionInfo.standardUsageAmount,
                StartMembershipWeeks: couponPromotionInfo.startMembershipWeeks,
                EndMembershipWeeks: couponPromotionInfo.endMembershipWeeks,
                CouponName: couponPromotionInfo.couponName,
                CouponNameKana: couponPromotionInfo.couponNameKana,
                CouponGuideName: couponPromotionInfo.couponGuideName,
                CouponGuideNameKana: couponPromotionInfo.couponGuideNameKana,
                CouponTitleEc: couponPromotionInfo.couponTitleEc,
                CouponTitleDelivery: couponPromotionInfo.couponTitleDelivery,
                ContentOne: couponPromotionInfo.contentOne,
                ContentTwo: couponPromotionInfo.contentTwo,
                ContentThree: couponPromotionInfo.contentThree,
                ContentFour: couponPromotionInfo.contentFour,
                ValidatedDate: couponPromotionInfo.validatedDate,
                StaffCouponFlg: couponPromotionInfo.staffCouponFlg,
                RegistFlg: couponPromotionInfo.registFlg,
                DeleteFlg: couponPromotionInfo.deleteFlg,
              }
            }
          })
        },
        CouponApplicablePrice: {
          combination: this.vo.couponApplicablePrice.map(couponApplicablePriceInfo => {
            return {
              parameter: {
                CouponGoodsNo: couponApplicablePriceInfo.couponGoodsNo,
                ItemCode: couponApplicablePriceInfo.itemCode,
                CoopCode: couponApplicablePriceInfo.coopCode,
                PlanGoodsCoopCouponApplicablePriceFlg: couponApplicablePriceInfo.planGoodsCoopCouponApplicablePriceFlg,
                DiscountUnitPrice: couponApplicablePriceInfo.discountUnitPrice,
                DiscountRate: couponApplicablePriceInfo.discountRate,
                LimitNum: couponApplicablePriceInfo.limitNum,
                CouponDiscountSupplyUnitPrice: couponApplicablePriceInfo.discountedUnitPrice,
              }
            }
          })
        },
        PlanGoodsEC: {
          parameter: {
            PCode: this.vo.planGoodsEC.pCode,
            CmFlg: this.vo.planGoodsEC.cmFlg,
            RecommendFlg: this.vo.planGoodsEC.recommendFlg,
            OrderLimitFlg: this.vo.planGoodsEC.orderLimitFlg,
            WebLimitFlg: this.vo.planGoodsEC.webLimitFlg,
            RecommendCommentFlg: this.vo.planGoodsEC.recommendCommentFlg,
            OrderGoodsDiv: this.vo.planGoodsEC.orderGoodsDiv,
            MinOrderNum: this.vo.planGoodsEC.minOrderNum,
            MaxOrderNum: this.vo.planGoodsEC.maxOrderNum,
            StockNum: this.vo.planGoodsEC.stockNum,
            StockNumShowFlg: this.vo.planGoodsEC.stockNumShowFlg,
            BrandName: this.vo.planGoodsEC.brandName,
            GroupingCode: this.vo.planGoodsEC.groupingCode,
            RelatedUrlTitle: this.vo.planGoodsEC.relatedUrlTitle,
            RelatedUrl: this.vo.planGoodsEC.relatedUrl,
            NonDispFlg: this.vo.planGoodsEC.nonDispFlg,
          }
        },
        PlanGoodsEcStock: {
          combination: this.vo.planGoodsEcStock.map(planGoodsEcStockInfo => {
            return {
              parameter: {
                CoopCode: planGoodsEcStockInfo.coopCode,
                StockNum: planGoodsEcStockInfo.stockNum,
                SupplyPrice: planGoodsEcStockInfo.supplyPrice,
                SupplyPriceExplanation: planGoodsEcStockInfo.supplyPriceExplanation,
              }
            }
          })
        },
        PreOrderInfo: {
          combination: this.vo.preOrderInfo.map(preOrderData => {
            return {
              parameter: {
                PCode: preOrderData.pCode,
                PreOrderDetailId: Number(preOrderData.preOrderDetailId),
                ItemCode: preOrderData.itemCode,
                PreOrderNumQuotaCode: preOrderData.preOrderNumQuotaCode,
                PreOrderNum: preOrderData.preOrderNum,
                DelivCatalogId: preOrderData.delivCatalogId,
                DelivMonday: preOrderData.delivMonday ? '1' : '0',
                DelivTuesday: preOrderData.delivTuesday ? '1' : '0',
                DelivWednesday: preOrderData.delivWednesday ? '1' : '0',
                DelivThursday: preOrderData.delivThursday ? '1' : '0',
                DelivFriday: preOrderData.delivFriday ? '1' : '0',
                PreOrderGoodsName: preOrderData.preOrderGoodsName,
                PreOrderGoodsNameKana: preOrderData.preOrderGoodsNameKana,
                PreOrderStandardName: preOrderData.preOrderStandardName,
                PreOrderStandardNameKana: preOrderData.preOrderStandardNameKana,
                DiscountType: preOrderData.discountType,
                DiscountUnitPrice: preOrderData.discountUnitPrice,
                DiscountRate: preOrderData.discountRate,
                DiscountSupplyUnitPrice: preOrderData.discountSupplyUnitPrice,
                PreOrderPoints: preOrderData.preOrderPoints,
                SetPreOrderType: preOrderData.setPreOrderType ? '1' : '0',
                PricePattern: preOrderData.pricePattern,
                SupplyUnitPrice: preOrderData.supplyUnitPrice,
                RegistFlg: preOrderData.registFlg,
                DeleteFlg: preOrderData.deleteFlg,
              }
            }
          })
        },
        PreOrderCoop: {
          combination: this.vo.preOrderCoop.map(preOrderCoopData => {
            return {
              parameter: {
                PreOrderDetailId: Number(preOrderCoopData.preOrderDetailId),
                ItemCode: preOrderCoopData.itemCode,
                CoopCode: preOrderCoopData.coopCode,
                PlanNum: preOrderCoopData.planNum,
                RegistFlg: preOrderCoopData.registFlg,
                DeleteFlg: preOrderCoopData.deleteFlg
              }
            }
          })
        },
        CwsPlanGoodsIcon: {
          combination: this.vo.cwsPlanGoodsIcon.map(cwsIconInfo => {
            return {
              parameter: {
                OrderCode: cwsIconInfo.orderCode,
                PCode: cwsIconInfo.pCode,
                IconCode: cwsIconInfo.iconCode,
                ArrangeDiv: cwsIconInfo.arrangeDiv,
                PublishOrder: cwsIconInfo.publishOrder,
                Icon0: cwsIconInfo.icon0,
                Icon1: cwsIconInfo.icon1,
                Icon2: cwsIconInfo.icon2,
                Icon3: cwsIconInfo.icon3,
                Icon4: cwsIconInfo.icon4,
                Icon5: cwsIconInfo.icon5,
                Icon6: cwsIconInfo.icon6,
                Icon7: cwsIconInfo.icon7,
              }
            }
          })
        }
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @param {Function} successFunc 成功時後続処理
   * @memberof CheckPlanGoodsService
   */
  execute(model: any, vo: CheckPlanGoodsRequestModel, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('checkPlanGoods', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckPlanGoodsService
   */
  success(data: any): void {

    if (data === null) { // データが無い場合
      // ワーニングリストのノード自体が存在しない
      // 画面遷移する
      this.model.showChangeConfirmation(data);
    } else {
      // ワーニングリストが存在
      this.arrayWarningMsg = data;
      if (this.arrayWarningMsg.length === 0) {
        // ワーニングが存在しないときは画面遷移
        this.model.showChangeConfirmation(data);
      } else {
        // ワーニングメッセージをポップアップする処理
        this._serverData = data; // サーバーデータを一時待避
        this.warningMsgIndex = 0; // ワーニングメッセージIndexを初期化
        this.model.kymw0900Component.dialogServiceSub.openAlertGetMessage(
          this.arrayWarningMsg[this.warningMsgIndex].MessageID, // メッセージID
          [
            this.arrayWarningMsg[this.warningMsgIndex].Parameter1, // メッセージ用パラメタ１
            this.arrayWarningMsg[this.warningMsgIndex].Parameter2, // メッセージ用パラメタ２
            this.arrayWarningMsg[this.warningMsgIndex].Parameter3, // メッセージ用パラメタ３
            this.arrayWarningMsg[this.warningMsgIndex].Parameter4 // メッセージ用パラメタ４
          ],
          (closeDetail) => {
            this.closeHandler(closeDetail);
          } // クローズハンドラ
        );
      }
    }
  }

  /**
  * クローズハンドラ
  */
  public closeHandler(closeDetail: any): void {
    this.warningMsgIndex++; // インデックスを一つ進める。
    // 確認ダイアログで「はい」を押しているか確認
    if (closeDetail === PlessAlert.Yes) {
      // 「はい」を押された &&いまが最後なら
      if (this.warningMsgIndex === this.arrayWarningMsg.length) {
        // 変更確認画面を起動
        this.model.showChangeConfirmation(this._serverData);
      } else {
        // OK顔された && 後続のワーニングがある。
        // 次のワーニングを実行
        this.model.kymw0900Component.dialogServiceSub.openAlertGetMessage(
          this.arrayWarningMsg[this.warningMsgIndex].MessageID, // メッセージID
          [
            this.arrayWarningMsg[this.warningMsgIndex].Parameter1, // メッセージ用パラメタ１
            this.arrayWarningMsg[this.warningMsgIndex].Parameter2, // メッセージ用パラメタ２
            this.arrayWarningMsg[this.warningMsgIndex].Parameter3, // メッセージ用パラメタ３
            this.arrayWarningMsg[this.warningMsgIndex].Parameter4 // メッセージ用パラメタ４
          ],
          (closeDetail) => {
            this.closeHandler(closeDetail);
          } // クローズハンドラ（自身を再帰呼び出し）
        );
      }
    } else {
      // 「いいえ」が押された、または、エラーダイアログの場合なにもしない
    }
  }
}
